module.exports = __webpack_public_path__ + "static/img/defender3.291b895.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/defender3.png
// module id = Y9Lb
// module chunks = 0